import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Folder } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  folder: Identifiable<Folder>;
  retrieveDocuments(req: Boundaries["retrieveDocuments"]["request"]): void;
}

function useRetrieveDocuments(namespace: string, type: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDocumentsRequestPending(namespace, type),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDocumentsRequestSuccess(namespace, type),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDocumentsRequestFailure(namespace, type),
    ),
    folder: useSelector(() => selector.getDocuments(namespace, type)),
    retrieveDocuments: core.retrieveDocuments,
  };
}

export { useRetrieveDocuments };
